import { render } from "./FirstPressing.vue?vue&type=template&id=6caf5c3a&scoped=true"
import script from "./FirstPressing.vue?vue&type=script&lang=js"
export * from "./FirstPressing.vue?vue&type=script&lang=js"

import "./FirstPressing.vue?vue&type=style&index=0&id=6caf5c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6caf5c3a"]])

export default __exports__